module.exports = __webpack_public_path__ + "static/media/20170806_22day_1083AT.5d5982d9.jpg";